import { render, staticRenderFns } from "./SingleMailController.vue?vue&type=template&id=7824e307"
import script from "./SingleMailController.vue?vue&type=script&lang=js"
export * from "./SingleMailController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports